if($('.construction-projects').length) {

    let buildingTypes = $('input[name=building-type]'),
        buildingServices = $('input[name=building-service]'),
        buildingLocations = $('input[name=building-location]'),
        activeFiltersContainer = $('.interface-active-filters'),
        activeFiltersItems = $('.active-filters'),
        resetButton = $('.reset-all-filters-button');

    $('.property-type-dropdown-container .dropdown-menu').on('click', function (e) { e.stopPropagation(); });

    buildingTypes.on('change update', function () {
        caseStudySearch();
    });

    buildingServices.on('change update', function () {
        caseStudySearch();
    });

    buildingLocations.on('change update', function () {
        caseStudySearch();
    });

    caseStudySearch();

    function caseStudySearch() {

        let searchCriteria = {
            types: [],
            services: [],
            locations: []
        },
        resultsShowing = 0;

        buildingTypes.each(function () {
            if($(this).is(":checked")) searchCriteria.types.push(parseInt($(this).val()));
        });

        buildingServices.each(function () {
            if($(this).is(":checked")) searchCriteria.services.push(parseInt($(this).val()));
        });

        buildingLocations.each(function () {
            if($(this).is(":checked")) searchCriteria.locations.push(parseInt($(this).val()));
        });

        $(window.case_studies).each(function (i, e) {

            let matchesQuery = {
                type: false,
                service: false,
                location: false
            };

            if(searchCriteria.types.length) {
                $(e.types).each(function (i2, e2) {
                    if(searchCriteria.types.indexOf(e2) !== -1) matchesQuery.type = true;
                });
            } else {
                matchesQuery.type = true;
            }

            if(searchCriteria.services.length) {
                $(e.services).each(function (i2, e2) {
                    if(searchCriteria.services.indexOf(e2) !== -1) matchesQuery.service = true;
                });
            } else {
                matchesQuery.service = true;
            }

            if(searchCriteria.locations.length) {
                $(e.locations).each(function (i2, e2) {
                    if(searchCriteria.locations.indexOf(e2) !== -1) matchesQuery.location = true;
                });
            } else {
                matchesQuery.location = true;
            }

            if(matchesQuery.type && matchesQuery.service && matchesQuery.location) {
                $('#case-study-list-item-' + e.ID).removeClass('hidden');
                resultsShowing++;
            } else {
                $('#case-study-list-item-' + e.ID).addClass('hidden');
            }

        });

        displayFilters(searchCriteria);

        displayFillers(resultsShowing);

    }

    function displayFilters(searchCriteria) {

        if(searchCriteria.types.length || searchCriteria.services.length || searchCriteria.locations.length) {
            activeFiltersContainer.removeClass('hidden');

            let allActiveFilters = [];

            $(searchCriteria.types).each(function (i, e) {
                allActiveFilters.push(window.case_study_taxonomies[e]);
            });

            $(searchCriteria.services).each(function (i, e) {
                allActiveFilters.push(window.case_study_taxonomies[e]);
            });

            $(searchCriteria.locations).each(function (i, e) {
                allActiveFilters.push(window.case_study_taxonomies[e]);
            });

            let activeFiltersContent = '';

            $(allActiveFilters).each(function (i, e) {
                activeFiltersContent += '<div class="active-filter-item" data-filter-id="' + e.term_id + '"><span>' + e.name + '</span><div class="filter-remove"></div></div>';
            });

            activeFiltersItems.html(activeFiltersContent);

        } else {
            // hide row altogether
            activeFiltersContainer.addClass('hidden');
        }

    }

    function displayFillers(resultsShowing) {

        let filtersToShow = 3 - (resultsShowing % 3);
        if(filtersToShow > 2) filtersToShow = 0;

        console.log(filtersToShow);

        $('.filler-item').addClass('hidden');

        for(let i = 0; i < filtersToShow; i++) {
            $('.filler-item-' + i).removeClass('hidden');
        }

    }

    resetButton.on('click', function () {
        buildingTypes.prop('checked', false);
        buildingServices.prop('checked', false);
        buildingLocations.prop('checked', false);

        caseStudySearch();
    });

    $(document).on('click', '.active-filter-item', function () {
        $('.filter-control-' + $(this).data('filter-id')).find('input').prop('checked', false);
        caseStudySearch();
    })

}
